<div class="nx-margin-bottom-2m">
  <app-error header="authentication.title" message="authentication.message" />
</div>

<qbe-panel-component *ngIf="isDev">
  <nx-error>
    <p class="azt-test" nxCopytext="normal">
      This component is for development purposes only. Would not be available in
      production mode.<br /><b>Please check your environment config.</b>
    </p>
  </nx-error>

  <form [formGroup]="formGroup" class="page-container">
    <div class="nx-margin-bottom-m">
      <nx-formfield label="Grant type">
        <input nxInput type="text" formControlName="grantType" readonly />
      </nx-formfield>
    </div>
    <div class="nx-margin-bottom-m">
      <nx-formfield label="Client ID">
        <input nxInput type="text" formControlName="clientId" />
      </nx-formfield>
    </div>
    <div class="nx-margin-bottom-m">
      <nx-formfield label="Client Secret">
        <input nxInput type="text" formControlName="clientSecret" />
      </nx-formfield>
    </div>
    <button nxButton (click)="handleSave()">Authenticate</button>
  </form>
</qbe-panel-component>

<div *ngIf="isDev" class="nx-margin-top-m">
  <qbe-panel-component >
    <form [formGroup]="formGroupSessionAuth" class="page-container">
      <div class="nx-margin-bottom-m">
        <nx-formfield label="Session ID">
          <input nxInput type="text" formControlName="sessionAuth" />
        </nx-formfield>
      </div>
      <button nxButton (click)="authBySession()">Authenticate</button>
    </form>
  </qbe-panel-component>
</div>